export enum JobInstagramPlacement {
    Feed = 'feed',
    Explore = 'explore',
    Stories = 'stories',
    Reels = 'reels',
}

export const getJobInstagramPlacementDisplayName = (instagramPlacement: JobInstagramPlacement): string => {
    switch (instagramPlacement) {
        case JobInstagramPlacement.Feed:
            return 'Feed';
        case JobInstagramPlacement.Explore:
            return 'Explore';
        case JobInstagramPlacement.Stories:
            return 'Stories';
        case JobInstagramPlacement.Reels:
            return 'Reels';
    }
};
